import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";
import type { ICaaOrder } from "@repo/shopify/queries/customer-account-gql";
import { extractId } from "@repo/shopify/utils/common";
import { OrderStatusTrans, getTrackingInfoCaa } from "@repo/shopify/utils/order";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import Image from "@atoms/Image";
import Link from "@atoms/Link";
import Price from "@atoms/Price";

import { URLS } from "@const/urls";

import useOrderStatusCaa from "@hooks/useOrderStatusCaa";

// classic OrderHistoryCard와 동일한 레이아웃이지만 jp는 반품(RETURN)과 주문 취소(CANCEL) 모두 제공하지 않아
// 상태 버튼(OrderStatusButton) 없이 상태 텍스트만 노출
export default function OrderHistoryCardJp({ node }: { node: ICaaOrder }) {
  const { t } = useTranslation();
  const { isPC } = useCheckDevice();

  const { orderStatus } = useOrderStatusCaa(node);

  const trackingInfo = getTrackingInfoCaa(node);

  return (
    <li className="pc:col-span-10 pc:grid-cols-subgrid pc:gap-y-0 col-span-8 grid grid-cols-subgrid gap-y-4">
      <div className="pc:col-span-1 col-span-3 col-start-1 flex flex-col gap-1.5">
        <Link as="wrapper" className="pc:gap-1.5 flex! flex-col gap-2" href={`${URLS.ORDER}${extractId(node.id)}`}>
          <div className="text-md flex flex-col gap-0.5 leading-none">
            <span>{node.name}</span>
            <span>{dayjs(node.processedAt).format("MMM DD, YYYY")}</span>
          </div>
          <span className="text-md leading-none">{orderStatus ? t(OrderStatusTrans[orderStatus]) : orderStatus}</span>
        </Link>
        {trackingInfo ? (
          <Link as="text" className="text-md w-fit leading-none font-normal underline" href={trackingInfo.url ?? ""}>
            {trackingInfo.number}
          </Link>
        ) : null}
      </div>
      {node.lineItems.edges.length > 0 ? (
        <Link
          as="wrapper"
          className="pc:col-span-3 pc:col-start-2 pc:row-start-1 col-span-8 col-start-1 row-start-2 flex flex-col"
          href={`${URLS.ORDER}${extractId(node.id)}`}
        >
          <ol className="text-md flex flex-col gap-1 leading-none">
            {node.lineItems.edges.map((item, index) => (
              <li key={`${node.id}-${index}-title`}>
                <span>{item.node.title}</span>
              </li>
            ))}
          </ol>
        </Link>
      ) : null}
      {isPC ? (
        <Link as="wrapper" className="pc:col-span-1 col-span-3 block" href={`${URLS.ORDER}${extractId(node.id)}`}>
          <Price className="text-md leading-none" price={parseFloat(node.totalPrice.amount)} />
        </Link>
      ) : null}
      <Link
        as="wrapper"
        className="pc:col-span-4 pc:col-start-6 pc:row-start-1 col-span-8 row-start-3 block"
        href={`${URLS.ORDER}${extractId(node.id)}`}
      >
        <ol className="flex flex-wrap gap-1">
          {node.lineItems.edges.map((item, index) => (
            <li key={`${node.id}-${index}-thumbnail`}>
              <Image
                className="pc:w-20 pc:max-w-20 w-15 max-w-15"
                height={1707}
                src={item.node.image?.url || node.featuredImage?.value || ""}
                width={1280}
              />
            </li>
          ))}
        </ol>
      </Link>
      <div className="pc:col-start-11 pc:gap-0 pc:col-span-1 pc:flex-row pc:justify-end pc:items-start col-span-3 col-start-6 flex flex-col items-end gap-2">
        {!isPC && <Price className="text-md leading-none" price={parseFloat(node.totalPrice.amount)} />}
      </div>
    </li>
  );
}
